import React from 'react';
import { ChosenCharityContext } from './chosenCharityProvider';

export const useChosenCharity = () => React.useContext(ChosenCharityContext);
